export default {
  FETCH_TOTAL_EARNINGS_BY_TYPE: 'FETCH_TOTAL_EARNINGS_BY_TYPE',
  FETCH_TOTAL_EARNINGS_BY_TYPE_SUCCESS: 'FETCH_TOTAL_EARNINGS_BY_TYPE_SUCCESS',
  FETCH_TOTAL_EARNINGS_BY_TYPE_ERROR: 'FETCH_EARNINGS_ERROR',
};
